var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('H3Title',{attrs:{"title":'逻辑详解'}}),_c('div',{staticStyle:{"width":"100%","height":"300px"},attrs:{"id":"wwave"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }